// extracted by mini-css-extract-plugin
export default {"wrapper":"ColorBoxes-module__wrapper","colorbox":"ColorBoxes-module__colorbox","active":"ColorBoxes-module__active"};